module.exports = __webpack_public_path__ + "static/media/Cartela_H_gris.ac5d3c86.svg";